<template>
  <div class="mobileLayout">
    <div class="item">
      <div class="itemTitle">选择产品</div>
      <div class="itemProduct">
        <div class="itemText">
          {{ productName ? productName : "选择您本次要推广的产品" }}
        </div>
        <el-button class="selectProduct" @click="selectProductEntry">
          <span class="deleteButton">选择产品</span>
        </el-button>
      </div>
    </div>
    <div class="item">
      <div class="itemTitle">定制文案风格</div>
      <div class="itemForm">
        <el-form label-position="top" label-width="80px" class="form">
          <div class="XHForm">
            <div class="XHFormLabel">文案类型</div>
            <div class="XHFormItem">
              <el-select
                :disabled="!!generating"
                style="display: block"
                v-model="copywritingType"
                filterable
                allow-create
                default-first-option
                placeholder="请选择文案类型"
              >
                <el-option
                  v-for="item in copywritingTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">文案风格</div>
            <div class="XHFormItem">
              <el-select
                :disabled="!!generating"
                style="display: block"
                v-model="copywritingStyle"
                filterable
                allow-create
                default-first-option
                placeholder="请选择文案风格"
              >
                <el-option
                  v-for="item in copywritingStyleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">关键词</div>
            <div class="XHFormItem">
              <el-input
                :disabled="!!generating"
                v-model="keyWords"
                placeholder="请输入文案想要包含的关键词，以逗号分隔"
                style="width: 100%"
                default-first-option
                :automatic-dropdown="false"
                filterable
                multiple
                allow-create
              />
            </div>
          </div>
          <div class="XHForm">
            <div class="XHFormLabel">生成</div>
            <div class="XHFormItem">
              <div class="selector">
                <div class="chattoolsItemStyle generatorSelect">
                  <el-select
                    :disabled="!!generating"
                    style="background-color: aliceblue"
                    v-model="generatorNum"
                  >
                    <el-option
                      v-for="n in 3"
                      :key="n"
                      :label="n + ' 篇'"
                      :value="n"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="chattoolsItemStyle generatorSelect">
                  <el-select style="background-color: aliceblue" v-model="long">
                    <el-option
                      v-for="n in [
                        { label: '短文案', value: '短' },
                        { label: '长文案', value: '长' },
                      ]"
                      :key="n.label"
                      :label="n.label"
                      :value="n.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="buttonWrapper">
            <el-button
              :disabled="!!generating"
              @click="generatorArticle"
              style="
                border-radius: 1.5rem;
                height: 3rem;
                width: 300px;
                background: linear-gradient(150deg, #7ba0ff, #ee74ff);
                color: #ffffff;
              "
            >
              立即生成
            </el-button>
            <div>
              版权相关请查看<el-button
                type="text"
                @click="dialogVisible = true"
              >
                《创作版权说明》
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <SelectProduct
      v-if="showProductPage"
      :productList="productList"
      :getProductList="getProductList"
      :selectProduct="selectProduct"
      :closeSelectProduct="closeSelectProduct"
    />
    <ChangeWordsEntry :visible="changeWordsDialogVisible" :close="close" />
    <GeneralChat
      v-if="chatPage"
      :loading="loading"
      :generating="generating"
      :closeChatPage="closeChatPage"
      :stopGeneratArticle="stopGeneratArticle"
      :copywritingList="copywritingList"
      :editArticleContent="editArticleContent"
      :copyContent="copyContent"
      :revertArticleContent="revertArticleContent"
      :finishEditArticleContent="finishEditArticleContent"
      :setArticleStar="setArticleStar"
    />
    <el-dialog
      :visible.sync="dialogVisible"
      style="min-width: 300px; border-radius: 8px"
    >
      <div class="dialogWrapper">
        <div class="title">CeMeta 创作版权说明</div>
        <div class="time">更新时间: 2023年7月25日</div>
        <div class="time">生效时间: 2023年7月25日</div>
        <div class="content">
          <div class="contentItem">
            为进一步明确CeMeta旗下相关产品内容版权生成与使用规范，特作出如下约定：
          </div>
          <div class="contentItem">
            1.CeMeta旗下产品内容，是指CeMeta旗下产品所创作、生成的AI内容，包括但不限于基于模型生成的文案、图片、动画和音视频素材。其所述产品包括但不限于CeMeta旗下的CeMeta
            AI小红书文案助手、CeMeta营销物料助手、CeMeta AI静物图等平台。
          </div>
          <div class="contentItem">
            2.您在使用本服务时发布上传的内容均应为您原创或已获合法授权（且含转授权），上传内容的知识产权或相关合法权益归您或您享有合法使用权，同时您应确保上传内容不侵犯任何人的知识产权、名誉权、姓名权、隐私权、商业秘密等合法权益，否则由此产生的侵权风险和责任由您承担，相应纠纷应由您负责解决，并且您应赔偿我们由此遭受的全部直接、间接损失（包括但不限于经济、商誉、维权支出、律师费等损失）。同时，对于您发布上传的内容，您授予CeMeta平台一项无偿、无需标注您个人身份的、在法律允许范围内合理且最大程度的权益，允许我们使用您的内容向您提供服务、改进和提升我们的服务，用来提升我们的算法服务。如果您不愿意向我们提供前述授权的，请您立即停止使用我们的服务。
          </div>
          <div class="contentItem">
            3.CeMeta旗下产品所创作AI内容，其版权与最终解释权归属CeMeta所有。本服务以及因使用本服务所取得的任何产出或成果，仅限您本人用于学术测试目的，未经CeMeta平台事前书面同意，您不得将其所创作内容用于任何商业或其他目的与用途，且不得自行或透过他人以任何方式或载体向第三方披露、提供、转发、传播或公开。
          </div>
          <div class="contentItem">
            4.CeMeta所创作的AI内容属于人工智能深度合成内容，将严格遵守国家《互联网信息服务深度合成管理规定》所示规定。同时，您理解并同意，本服务尚存在不完备性，我方不对任何服务可用性、可靠性做出任何承诺。我方不对您使用本服务或其产出成果承担任何责任，且本服务结果不代表我方立场，请您谨慎使用。
          </div>
          <div class="contentItem">
            5.在任何情况下，CeMeta平台均不就因本服务所发生的任何直接性、间接性、后果性、惩戒性、偶然性、特殊性的损害
            (包括但不限于：您使用本服务而遭受的利润损失)，承担任何责任(即使您已事先被告知该等损害发生的可能性)。如因您在使用中发生任何争议或不当言论，其责任由您自行承担。
          </div>
          <div class="contentItem">
            6.对于您使用CeMeta平台，上传、提交、发布、存储、发送、接收、传播或分享的内容，我们仅在有关法律、法规、国家政策等规定或者相关国家机关的要求的前提下，自行或委托第三方进行查看、审阅、分析、讨论等，并有权将该等内容提供给相关国家机关审阅并用于其所需的目的。我们自行或委托第三方对该等内容进行查看、审阅、分析、讨论的行为，不代表我们对该等内容承担任何审查或保证责任，亦不豁免您因违反该条约定而需承担的本协议约定的违约责任。
          </div>
          <div class="contentItem">
            7.您理解并且同意，为持续改善CeMeta平台为您提供的各项服务，除非有相反证明，您使用CeMeta平台服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销的、免费的授予CeMeta平台及其关联方对该内容的存储、使用、发布、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您的上传、发布的内容进行商业开发的权利；通过有线或无线网络向计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）、手持数字影音播放设备、电视接收设备（模拟信号接收设备、数字信号接收设备、数字电视、IPTV、电视机机顶盒、视频投影仪、车载电视、互联网电视/OTT终端、智能电视等带互联网接入功能的播放设备等）、智能音响等智能硬件终端等提供信息的下载、点播、语音播放、数据传输、音频业务、移动视频业务（包括但不限于SMS、MMS、WAP、IVR、Streaming、手机视频等无线服务）及其相关宣传和推广等服务的权利；以及再授权给其他第三方以上述方式使用的权利。
          </div>
          <div class="contentItem">
            8.通过CeMeta旗下产品授权使用的单位，不应超越其与CeMeta平台所属方签署的具体的授权范围。
          </div>
          <div class="contentItem">
            9.如因作品内容、版权和其它问题需要同本网站联系的，请您在知悉该作品确有争议后30日内联系本网站，并提供相应的联系方式、权属证明、涉嫌侵权内容及其在网站上的位置等信息，以便我们查明情况并帮助您维权。
          </div>
          <div class="contentItem">
            CeMeta平台提示您注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定其是否侵犯了其合法权益，平台建议您首先咨询专业人士。
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../http/api";
import {
  copywritingTypeList,
  copywritingStyleList,
} from "../../utils/constants";
import ChangeWordsEntry from "../industryChat/ChangeWordsEntry.vue";
import SelectProduct from "./SelectProduct.vue";
import GeneralChat from "./GeneralChat.vue";

export default {
  components: {
    ChangeWordsEntry,
    SelectProduct,
    GeneralChat,
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
    count() {
      return this.$store.state.count;
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  destroyed() {
    if (this.updateArticleTimer) {
      clearInterval(this.updateArticleTimer);
    }
  },
  data() {
    return {
      isMobile: false,
      showProductPage: false,
      chatPage: false,
      changeWordsDialogVisible: false,
      loading: false,
      generating: false,
      updateArticleTimer: null,
      targetAudience: [],
      productList: [],
      productName: "",
      copywritingList: [],
      generatorNum: 1,
      long: "短",
      copywritingStyle: [],
      copywritingType: [],
      keyWords: "",
      product: {
        industryType: "",
        subIndustryType: "",
        sellingPoint: "",
      },
      copywritingTypeList: copywritingTypeList,
      copywritingStyleList: copywritingStyleList,
      dialogVisible: false,
    };
  },
  methods: {
    close() {
      this.changeWordsDialogVisible = false;
    },
    closeChatPage() {
      this.chatPage = false;
      this.stopGeneratArticle();
    },
    async getProductList() {
      const res = await Api.Product.getProductList({
        type: "xiaohongshu-article",
      });

      if (res.data) {
        this.productList = res.data.map((a) => {
          return {
            id: a._id,
            value: a.data.productName,
            label: a.data.productName,
            industryType: a.data.industry,
            subIndustryType: a.data.subIndustry,
            targetAudience: a.data.targetAudience.split(","),
            productName: a.data.productName,
            sellingPoint: a.data.sellingPoint,
          };
        });
      }
    },
    async generatorArticle() {
      try {
        if (this.count < 200) {
          this.changeWordsDialogVisible = true;
          return;
        }
        if (!this.userName) {
          return this.$message.error("未登录");
        }
        if (!this.productName) {
          return this.$message.error("产品不能为空");
        }

        if (this.generating === false) {
          this.loading = true;
        }

        _baq.track("game_addiction", { assets_id: "1772924118818887" });
        this.chatPage = true;
        this.generating = true;
        const params = {
          payload: {
            productName: this.productName,
            targetAudience: this.targetAudience,
            articleType: this.copywritingType,
            articleStyle: this.copywritingStyle,
            sellingPoint: this.product.sellingPoint,
            keyWords: this.keyWords
              ? this.keyWords.includes("，")
                ? this.keyWords.split("，")
                : this.keyWords.split(",")
              : [],
            industry: this.product.subIndustryType,
            long: this.long,
          },
          type: "xiaohongshu_article_assistant",
        };

        let res = await Api.Chat.askForAI(params);

        if (res.data) {
          let res1 = await Api.Chat.getAnswerForAsk(res.data.id);
          let answer = res1.data;

          this.copywritingList.push({
            contentWords: answer.content,
            editContentWords: "",
            editStatus: false,
            isCopy: false,
            star: 0,
            agree: false,
            articleId: res.data.id,
          });

          if (!answer.isFinish) {
            this.updateArticleTimer = setInterval(async () => {
              let res2 = await Api.Chat.getAnswerForAsk(res.data.id);

              if (res2.data) {
                if (
                  res2.data.content !== "" &&
                  this.copywritingList[this.copywritingList.length - 1]
                    .contentWords !== res2.data.content
                ) {
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].contentWords = res2.data.content;
                  this.loading = false;
                }

                if (res2.data.isFinish) {
                  clearInterval(this.updateArticleTimer);
                  if (this.updateArticleTimer) {
                    await Api.Chat.saveCount({
                      type: "xiaohongshu_article_assistant",
                      id: res.data.id,
                      count: res2.data.content.length,
                    });
                  }

                  this.updateArticleTimer = null;
                  this.$store.dispatch("setCount");
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].editStatus = false;
                  this.copywritingList[
                    this.copywritingList.length - 1
                  ].isCopy = false;

                  if (this.copywritingList.length < this.generatorNum) {
                    this.generatorArticle();
                  } else {
                    this.generating = false;
                  }
                }
                window.scrollTo(
                  0,
                  document.getElementById("contentEle").scrollHeight
                );
              }
            }, 600);
          }
        } else {
          this.loading = false;
          this.generating = false;
          if (res.error.message === "Insufficient balance, please recharge") {
            return this.$message.error("暂时不能使用了，请联系管理员");
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async stopGeneratArticle() {
      clearInterval(this.updateArticleTimer);
      if (this.updateArticleTimer) {
        await Api.Chat.saveCount({
          type: "xiaohongshu_article_assistant",
          id: this.copywritingList[this.copywritingList.length - 1].articleId,
          count:
            this.copywritingList[this.copywritingList.length - 1].contentWords
              .length || 0,
        });
      }
      this.$store.dispatch("setCount");
      this.updateArticleTimer = null;
      this.generating = false;
      document
        .getElementById("contentEle")
        .scrollTo(0, document.getElementById("contentEle").scrollHeight);
    },
    editArticleContent(index) {
      if (!this.updateArticleTimer && !this.generating) {
        this.copywritingList[index].editContentWords =
          this.copywritingList[index].contentWords;
        this.copywritingList[index].editStatus = true;
      }
    },
    revertArticleContent(index) {
      this.copywritingList[index].editContentWords =
        this.copywritingList[index].contentWords;
      this.copywritingList[index].editStatus = false;
    },
    finishEditArticleContent(index) {
      this.copywritingList[index].contentWords =
        this.copywritingList[index].editContentWords;
      this.copywritingList[index].editContentWords = "";
      this.copywritingList[index].editStatus = false;
    },
    async copyContent(index) {
      const copyObj = new Clipboard(".copy_btn");

      copyObj.on("success", async () => {
        this.$message.success("复制成功");
        copyObj.destroy();
        if (!this.copywritingList[index].isCopy) {
          this.copywritingList[index].isCopy = true;
        }
      });
    },
    selectProductEntry() {
      this.showProductPage = true;
    },
    closeSelectProduct() {
      this.showProductPage = false;
    },
    selectProduct(item) {
      this.targetAudience = item.targetAudience;
      this.productName = item.productName;
      this.product.sellingPoint = item.sellingPoint;
      this.product.industryType = item.industryType;
      this.product.subIndustryType = item.subIndustryType;

      this.showProductPage = false;
    },
    async setArticleStar(index, starType) {
      if (!this.userName) {
        return this.$message.error("未登录");
      }
      const hasAgree = this.copywritingList[index].agree;
      const res = await Api.Chat.setArticleStar({
        article: btoa(encodeURI(this.copywritingList[index].contentWords)),
        type: "xiaohongshu-article",
        agree: starType,
        cancelAgree:
          (hasAgree === "up" && starType) || (hasAgree === "down" && !starType)
            ? true
            : undefined,
        title: this.productName,
        articleAskId: this.copywritingList[index].articleId,
      });

      if (res.error) {
        return this.$message.error("评分失败");
      }

      this.copywritingList[index].id = res.data.id;
      this.copywritingList[index].agree = starType ? "up" : "down";
      this.$message.success("评分成功");
    },
  },
  created() {
    const isMobile = window.navigator.userAgent.includes("Mobile");
    if (!isMobile) {
      window.location.href = "/industryChat";
    } else {
      this.isMobile = isMobile;
    }
  },
};
</script>
<style lang="less" scoped>
.mobileLayout {
  padding: 16px 20px;
  position: relative;

  .item {
    .itemTitle {
      color: #111d3a;
      font-weight: bold;
    }
    .itemProduct {
      color: rgba(17, 29, 58, 0.4);
      background-color: rgba(167, 167, 167, 0.13);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      border-radius: 8px;
      margin-top: 12px;
    }

    .itemForm {
      margin-top: 12px;
    }
  }

  .item + .item {
    margin-top: 16px;
  }

  .form {
    > :first-child {
      margin-top: 16px;
    }
    > :not(:first-child) {
      margin-top: 12px;
    }

    .buttonWrapper {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: rgba(17, 29, 58, 0.5);
      font-size: 12px;
    }
  }

  .XHForm {
    .XHFormLabel {
      margin-bottom: 12px;
      font-weight: 500;
      span {
        color: red;
        margin-right: 4px;
      }
    }
    .selector {
      display: flex;
      gap: 12px;
      .generatorSelect {
        flex: 1;
      }
    }
  }

  .dialogWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title {
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      color: #111b3a;
      line-height: 64px;
      text-align: center;
    }
    .time {
      font-size: 16px;
      font-weight: 500;
      color: #111b3a;
    }
    .content {
      margin: 26px 0;
      font-size: 15px;
      font-weight: 500;
      color: #111b3a;
      line-height: 22px;
    }
  }

  /deep/ .el-dialog {
    min-width: 300px;

    .el-dialog__body {
      padding-top: 0;
    }
  }

  .selectProduct {
    border-radius: 1rem;
    height: 2rem;
    background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    position: relative;
    overflow: hidden;
    color: #a78fff;
    padding: 4px 10px;

    > :first-child::before {
      background: #fff;
      content: " ";
      display: block;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      top: 1px;
      left: 1px;
      position: absolute;
      border-radius: 24px;
    }
    .deleteButton {
      z-index: 2;
      position: relative;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobileChat/index.vue